/**
 * Created by Codex on 16.07.2026
 */

class InflateComponent extends BaseComponent {
    onCreate() {
        this.avoidingNodes = [];
        this.debugBorderNodes = [];
    }

    addAvoidingNode(nodeOrFactory, options) {
        options = options || {};

        const item = { nodeOrFactory };
        this.avoidingNodes.push(item);

        if (!options.silent) {
            this.inflate();
        }

        let removed = false;
        return () => {
            if (removed) {
                return;
            }

            removed = true;
            const index = this.avoidingNodes.indexOf(item);
            if (index !== -1) {
                this.avoidingNodes.splice(index, 1);
            }

            if (!options.silent) {
                this.inflate();
            }
        };
    }

    getAvoidingNodes() {
        const avoidingNodes = [];

        const add = (node) => {
            if (!node) {
                return;
            }

            if (Array.isArray(node)) {
                node.forEach(add);
                return;
            }

            avoidingNodes.push(node);
        };

        this.avoidingNodes.forEach((item) => {
            add(typeof item.nodeOrFactory === "function" ? item.nodeOrFactory() : item.nodeOrFactory);
        });

        return avoidingNodes;
    }

    inflate() {
        this.clearDebugBorders();

        const target = this.options.getTarget ? this.options.getTarget.call(this.node) : this.options.target;
        if (!target) {
            return;
        }

        const options = this.options.getOptions ? this.options.getOptions.call(this.node) : (this.options.options || {});
        const avoidingNodes = this.getAvoidingNodes();

        if (this.options.beforeInflate) {
            this.options.beforeInflate.call(this.node, cleverapps.UI.calcBoundaries(avoidingNodes, options), avoidingNodes, options);
        }

        cleverapps.UI.inflateToBoundaries(target, avoidingNodes, options);

        if (this.options.afterInflate) {
            this.options.afterInflate.call(this.node, target, avoidingNodes, options);
        }

        const settled = this.getAvoidingNodes();
        if (!this.settling && (settled.length !== avoidingNodes.length || settled.some((node, i) => node !== avoidingNodes[i]))) {
            this.settling = true;
            this.inflate();
            this.settling = false;
            return;
        }

        this.updateDebugBorders(target, avoidingNodes);
    }

    updateDebugBorders(target, avoidingNodes) {
        if (!cleverapps.config.debugMode || !cleverapps.flags.get("showInflateBoundaries")) {
            return;
        }

        const nodes = [
            {
                node: target,
                color: new cc.Color(0, 255, 0, 255),
                labelText: "inflate target"
            },
            ...avoidingNodes.map((node, index) => ({
                node,
                color: new cc.Color(255, 0, 0, 255),
                labelText: `avoiding node ${index + 1}`
            }))
        ];

        nodes.forEach((item) => {
            if (!item.node || typeof item.node.debugBorder !== "function" || this.debugBorderNodes.includes(item.node)) {
                return;
            }

            item.node.debugBorder({
                color: item.color,
                labelText: item.labelText,
                permanent: true
            });
            this.debugBorderNodes.push(item.node);
        });
    }

    clearDebugBorders() {
        this.debugBorderNodes.forEach((node) => {
            if (node && typeof node.cleanupBorder === "function") {
                node.cleanupBorder({ permanent: true });
            }
        });
        this.debugBorderNodes = [];
    }

    onAfterResize() {
        this.inflate();
    }

    onDestroy() {
        this.clearDebugBorders();
    }

    static InflateGameField() {
        const scene = cleverapps.Scenes.GetRunningScene();
        const inflateComponent = scene && ComponentMap.get(scene, InflateComponent);
        if (inflateComponent) {
            inflateComponent.inflate();
        }
    }
}
